var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryBreast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 81,
    viewBox: "0 0 90 81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.535 80.28c0-7.2-5.729-28.629-17.186-64.285L1 14.911 33.336 1c2.519 2.547 6.33 4.038 11.432 4.474l.365.028.365-.028c4.938-.422 8.666-1.832 11.184-4.23L56.93 1l32.336 13.91-.349 1.085C77.46 51.651 71.732 73.08 71.732 80.281H18.535z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryBreast);
export default __webpack_public_path__ + "static/media/injury-breast.d90c221daab3a7b669080b25af13e771.svg";
export { ForwardRef as ReactComponent };